function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import isNil from 'ramda/src/isNil';
import values from 'ramda/src/values';
import ApiConstants from 'invision-core/src/api/constants';
import { MetadataThunkHelper, ThunkHelper } from 'invision-core';
import { CurrentCustomerSelector } from 'invision-core/src/components/customer/customer.selectors';
import { setChangeImmediately } from './products.wizard.actions';
import { PRODUCT_ORDER_WIZARD_MODE } from '../constants/products.wizard.constants';
import { buildSubmitOrderRequestData, buildSubmitGiftOrderRequestData, buildSubmitRestoreOrderRequestData } from '../helpers/products.order.actions.helpers';
import { getTransformedInstancePropertiesForItem, transformCartItemInstanceProperties } from '../helpers/instance.property.helper';
import { SUBSCRIPTION_RESTORE_ROUTE } from '../../components/customer/subscriptions/subscriptions.config';
import { BILLING_EFFECTIVE_DATE_INTENTION } from '../constants/wizard.constants';
var MAX_PRODUCT_CONTEXT_SEARCH_LENGTH = 50;
export var CALCULATE_PRODUCT_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_PRODUCT_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_PRODUCT_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_PRODUCT_ORDER_QUOTE_FAILURE'
};
var CALCULATE_PRODUCT_ORDER_QUOTE_TYPES = [CALCULATE_PRODUCT_ORDER_QUOTE.BEGIN, CALCULATE_PRODUCT_ORDER_QUOTE.SUCCESS, CALCULATE_PRODUCT_ORDER_QUOTE.FAILURE];
export var CALCULATE_RENEW_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_RENEW_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_RENEW_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_RENEW_ORDER_QUOTE_FAILURE'
};
var CALCULATE_RENEW_ORDER_QUOTE_TYPES = [CALCULATE_RENEW_ORDER_QUOTE.BEGIN, CALCULATE_RENEW_ORDER_QUOTE.SUCCESS, CALCULATE_RENEW_ORDER_QUOTE.FAILURE];
export var SEARCH_AVAILABLE_PRODUCTS = {
  BEGIN: 'SEARCH_AVAILABLE_PRODUCTS_BEGIN',
  SUCCESS: 'SEARCH_AVAILABLE_PRODUCTS_SUCCESS',
  FAILURE: 'SEARCH_AVAILABLE_PRODUCTS_FAILURE'
};
var SEARCH_AVAILABLE_PRODUCTS_TYPES = [SEARCH_AVAILABLE_PRODUCTS.BEGIN, SEARCH_AVAILABLE_PRODUCTS.SUCCESS, SEARCH_AVAILABLE_PRODUCTS.FAILURE];
export var RETRIEVE_PRODUCTS_CONTEXT = {
  BEGIN: 'RETRIEVE_PRODUCTS_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCTS_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCTS_CONTEXT_FAILURE'
};
var RETRIEVE_PRODUCTS_CONTEXT_TYPES = [RETRIEVE_PRODUCTS_CONTEXT.BEGIN, RETRIEVE_PRODUCTS_CONTEXT.SUCCESS, RETRIEVE_PRODUCTS_CONTEXT.FAILURE];
export var RETRIEVE_PRODUCT_CONTEXT = {
  BEGIN: 'RETRIEVE_PRODUCT_CONTEXT_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCT_CONTEXT_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCT_CONTEXT_FAILURE'
};
var RETRIEVE_PRODUCT_CONTEXT_TYPES = [RETRIEVE_PRODUCT_CONTEXT.BEGIN, RETRIEVE_PRODUCT_CONTEXT.SUCCESS, RETRIEVE_PRODUCT_CONTEXT.FAILURE];
export var LOAD_ADDITIONAL_EPISODES = {
  BEGIN: 'LOAD_ADDITIONAL_EPISODES_BEGIN',
  SUCCESS: 'LOAD_ADDITIONAL_EPISODES_SUCCESS',
  FAILURE: 'LOAD_ADDITIONAL_EPISODES_FAILURE'
};
var LOAD_ADDITIONAL_EPISODES_TYPES = [LOAD_ADDITIONAL_EPISODES.BEGIN, LOAD_ADDITIONAL_EPISODES.SUCCESS, LOAD_ADDITIONAL_EPISODES.FAILURE];
export var RETRIEVE_PRODUCTS_WITH_INFO_CONSTANTS = {
  BEGIN: 'RETRIEVE_PRODUCTS_WITH_INFO_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCTS_WITH_INFO_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCTS_WITH_INFO_FAILURE'
};
export var RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_CONSTANTS = {
  BEGIN: 'RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_FAILURE'
};
export var SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export var CLEAR_PRODUCT_ORDER_QUOTE = 'CLEAR_PRODUCT_ORDER_QUOTE';
export var SET_PRODUCT_ORDER_DISCRETIONARY_DISCOUNT = 'SET_PRODUCT_ORDER_DISCRETIONARY_DISCOUNT';
export var SET_PRODUCT_ORDER_COUPON_CODES = 'SET_PRODUCT_ORDER_COUPON_CODES';
export var SET_PREVIOUSLY_SELECTED_PAYMENT_INSTRUMENT_IDS = 'SET_PREVIOUSLY_SELECTED_PAYMENT_INSTRUMENT_IDS';
export var SET_SELECTED_PRODUCTS_SEARCH_OPTION = 'SET_SELECTED_PRODUCTS_SEARCH_OPTION';
export var CLEAR_SELECTED_OPTIONS = 'CLEAR_SELECTED_OPTIONS';
export var clearSelectedOptions = function clearSelectedOptions() {
  return {
    type: CLEAR_SELECTED_OPTIONS
  };
};
export var setProductOrderDiscretionaryDiscounts = function setProductOrderDiscretionaryDiscounts() {
  var discretionaryDiscounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    type: SET_PRODUCT_ORDER_DISCRETIONARY_DISCOUNT,
    payload: discretionaryDiscounts
  };
};
export var setPreviouslySelectedPaymentInstrumentIds = function setPreviouslySelectedPaymentInstrumentIds(previouslySelectedPaymentInstrumentIds) {
  return {
    type: SET_PREVIOUSLY_SELECTED_PAYMENT_INSTRUMENT_IDS,
    payload: previouslySelectedPaymentInstrumentIds
  };
};
export var setProductOrderCouponCodes = function setProductOrderCouponCodes() {
  var couponCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    type: SET_PRODUCT_ORDER_COUPON_CODES,
    payload: couponCodes
  };
};
export var CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE = {
  BEGIN: 'CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE_FAILURE'
};
var CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE_TYPES = [CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE.BEGIN, CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE.SUCCESS, CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE.FAILURE];
export var SET_SHOPPING_CART_FROM_QUOTE_DATA = 'SET_SHOPPING_CART_FROM_QUOTE_DATA';
export var STORE_MODIFY_REQUEST_DATA = 'STORE_MODIFY_REQUEST_DATA';
function getModifyOrderRequestData(modificationObject, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, shippingAddressId, shippingMethodId, shipToName, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode) {
  // Common request data object for CalculateModifyOrderQuote and SubmitModifyOrder
  var requestData = Object.assign({}, modificationObject, {
    DiscretionaryDiscountReasonCode: discretionaryDiscountReasonCode,
    DiscretionaryDiscounts: discretionaryDiscounts,
    RedemptionCodes: redemptionCodes
  });
  if (recordPaymentInfo) {
    requestData.PaymentInstrumentIds = paymentInstrumentIds;
  } else {
    requestData.PaymentInstruments = paymentInstruments;
  }
  var parsedDiscretionaryDiscountReasonCode = isNil(discretionaryDiscountReasonCode) ? null : Number(discretionaryDiscountReasonCode);
  if (parsedDiscretionaryDiscountReasonCode) {
    requestData.DiscretionaryDiscountReasonCode = parsedDiscretionaryDiscountReasonCode;
  }
  if (shippingAddressId) {
    requestData.ShippingAddressId = shippingAddressId;
    requestData.ShippingMethodId = shippingMethodId;
    requestData.ShipToName = shipToName;
  }
  if (requestData.ReplaceItems && requestData.ReplaceItems.length) {
    requestData.ReplaceItems = requestData.ReplaceItems.map(function (item) {
      return getTransformedInstancePropertiesForItem(item);
    });
  }
  return requestData;
}
export var calculateModifyOrderQuotePromise = function calculateModifyOrderQuotePromise(dispatch, customerId, modificationObject, paymentInstrumentIds) {
  var redemptionCodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var discretionaryDiscounts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var shippingAddressId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var shippingMethodId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var calculateShipping = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
  var calculateTaxes = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
  var useDefaults = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : true;
  var recordPaymentInfo = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : true;
  var paymentInstruments = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : [];
  var discretionaryDiscountReasonCode = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
  var requestData = getModifyOrderRequestData(modificationObject, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, shippingAddressId, shippingMethodId, '', redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode);
  if (shippingAddressId) {
    requestData.IncludeShippingMethods = true;
    requestData.ShipToName = 'ShipToName'; // ShipToName content is irrelevant to COQ but required for call to succeed
  }
  requestData.CalculateShipping = calculateShipping;
  requestData.CalculateTaxes = calculateTaxes;
  requestData.UseDefaults = useDefaults;
  return ThunkHelper(dispatch, CALCULATE_MODIFY_PRODUCT_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateModifyOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  }).then(function (responsePayload) {
    if (!calculateTaxes) {
      // we cannot call UpdateShoppingCart in Replace & Modify subscription flows
      // yet much of the UI for Replace depends on the ShoppingCart being populated, so populating it from quote data
      if (requestData.ReplaceItems && requestData.ReplaceItems.length) {
        dispatch({
          type: SET_SHOPPING_CART_FROM_QUOTE_DATA,
          payload: responsePayload,
          requestObject: requestData
        });
      }
      dispatch({
        type: STORE_MODIFY_REQUEST_DATA,
        requestObject: requestData
      });
    }
  });
};
export var calculateOrderQuotePromise = function calculateOrderQuotePromise(dispatch, customerId, shoppingCart) {
  var orderTaxLocation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var paymentInstrumentIds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var redemptionCodes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var discretionaryDiscounts = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var shippingAddressId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var shippingMethodId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var useDefaults = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
  var recordPaymentInfo = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : true;
  var paymentInstruments = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : [];
  var discretionaryDiscountReasonCode = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var requestData = {
    DiscretionaryDiscountReasonCode: discretionaryDiscountReasonCode,
    DiscretionaryDiscounts: discretionaryDiscounts,
    RedemptionCodes: redemptionCodes,
    ShoppingCart: transformCartItemInstanceProperties(shoppingCart),
    RecordPaymentInformation: recordPaymentInfo,
    ReturnSubscriptionPreviews: true,
    UseDefaults: useDefaults
  };
  if (recordPaymentInfo) {
    requestData.PaymentInstrumentIds = paymentInstrumentIds;
  } else {
    requestData.PaymentInstruments = [paymentInstruments];
  }
  if (orderTaxLocation) {
    requestData.OrderTaxLocation = orderTaxLocation;
  }
  if (shippingAddressId) {
    requestData.IncludeShippingMethods = true;
    requestData.ShippingAddressId = shippingAddressId;
    requestData.ShippingMethodId = shippingMethodId;
    requestData.ShipToName = 'ShipToName'; // ShipToName content is irrelevant to COQ but required for call to succeed
  }
  return ThunkHelper(dispatch, CALCULATE_PRODUCT_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  });
};
export var CALCULATE_COS_ORDER_QUOTE_FOR_SERVICE_FEATURES = {
  BEGIN: 'CALCULATE_COS_ORDER_QUOTE_FOR_SERVICE_FEATURES.BEGIN',
  SUCCESS: 'CALCULATE_COS_ORDER_QUOTE_FOR_SERVICE_FEATURES.SUCCESS',
  FAILURE: 'CALCULATE_COS_ORDER_QUOTE_FOR_SERVICE_FEATURES.FAILURE'
};
export var calculateChangeOfServiceOrderQuoteRequestPromise = function calculateChangeOfServiceOrderQuoteRequestPromise(dispatch, customerId, addItems, modifyItems, removeItems, paymentInstrumentIds) {
  var data = {
    AddItems: addItems,
    AllowPartialQuote: true,
    ChangeImmediately: true,
    ModifyItems: modifyItems,
    PaymentInstrumentIds: paymentInstrumentIds,
    RemoveItems: removeItems,
    ReturnSubscriptionPreviews: true
  };
  return ThunkHelper(dispatch, values(CALCULATE_COS_ORDER_QUOTE_FOR_SERVICE_FEATURES), {
    method: 'post',
    url: 'SubscriberManagement/CalculateChangeOfServiceOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var calculateRenewOrderQuotePromise = function calculateRenewOrderQuotePromise(dispatch, customerId, subscriptionId) {
  var paymentInstrumentIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var redemptionCodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var discretionaryDiscounts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var shippingAddressId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  var shippingMethodId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var calculateTaxes = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
  var useDefaults = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
  var requestData = {
    CalculateTaxes: calculateTaxes,
    DiscretionaryDiscounts: discretionaryDiscounts,
    RedemptionCodes: redemptionCodes,
    PaymentInstrumentIds: paymentInstrumentIds,
    SubscriptionId: subscriptionId,
    UseDefaults: useDefaults
  };
  if (shippingAddressId) {
    requestData.IncludeShippingMethods = true;
    requestData.ShippingAddressId = shippingAddressId;
    requestData.ShippingMethodId = shippingMethodId;
    requestData.ShipToName = 'ShipToName'; // ShipToName content is irrelevant to COQ but required for call to succeed
  }
  return ThunkHelper(dispatch, CALCULATE_RENEW_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/CalculateRenewOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  }).then(function (responsePayload) {
    dispatch({
      type: SET_SHOPPING_CART_FROM_QUOTE_DATA,
      payload: responsePayload,
      requestObject: requestData
      //requestObject: Object.assign({}, requestData, {
      //    requestType: PRODUCT_ORDER_WIZARD_MODE.RESTORE
      //})
    });
  });
};
export var clearProductOrderQuote = function clearProductOrderQuote() {
  return {
    type: CLEAR_PRODUCT_ORDER_QUOTE
  };
};
export var GET_PRODUCT_METADATA_EVENT_TYPES = {
  BEGIN: 'GET_PRODUCT_METADATA_BEGIN',
  SUCCESS: 'GET_PRODUCT_METADATA_SUCCESS',
  FAILURE: 'GET_PRODUCT_METADATA_FAILURE'
};
var GET_PRODUCT_METADATA_EVENTS = [GET_PRODUCT_METADATA_EVENT_TYPES.BEGIN, GET_PRODUCT_METADATA_EVENT_TYPES.SUCCESS, GET_PRODUCT_METADATA_EVENT_TYPES.FAILURE];
export var GET_PRODUCT_METADATA_BATCH = {
  BEGIN: 'GET_PRODUCT_METADATA_BATCH_BEGIN',
  SUCCESS: 'GET_PRODUCT_METADATA_BATCH_SUCCESS',
  FAILURE: 'GET_PRODUCT_METADATA_BATCH_FAILURE'
};
export var getProductMetadata = function getProductMetadata(productId) {
  return function (dispatch, getState) {
    var customer = CurrentCustomerSelector(getState());
    return getProductMetadataPromise(dispatch, productId, customer.Language);
  };
};
export var getProductMetadataBatch = function getProductMetadataBatch(productIds) {
  return function (dispatch, getState) {
    var customer = CurrentCustomerSelector(getState());
    return getProductMetadataBatchPromise(dispatch, productIds, customer.Language);
  };
};
export var getProductMetadataBatchPromise = function getProductMetadataBatchPromise(dispatch, productIds, customerLanguage) {
  dispatch({
    type: GET_PRODUCT_METADATA_BATCH.BEGIN
  });
  var promises = [];
  productIds.forEach(function (id) {
    promises.push(getProductMetadataPromise(dispatch, id, customerLanguage));
  });
  return Promise.all(promises).then(function () {
    dispatch({
      type: GET_PRODUCT_METADATA_BATCH.SUCCESS
    });
  }).catch(function () {
    dispatch({
      type: GET_PRODUCT_METADATA_BATCH.FAILURE
    });
  });
};
export var getProductMetadataPromise = function getProductMetadataPromise(dispatch, productId, customerLanguage) {
  return MetadataThunkHelper(dispatch, GET_PRODUCT_METADATA_EVENTS, {
    url: "Product/Id/".concat(productId),
    headers: _defineProperty({}, ApiConstants.LANGUAGE_HEADER, customerLanguage)
  }, {
    productId: productId
  });
};
export var searchAvailableProductsPromise = function searchAvailableProductsPromise(dispatch, searchProductsParam, requestObject, customerId) {
  var options = {
    method: 'post',
    url: 'SubscriberManagement/SearchCatalog',
    data: searchProductsParam
  };
  if (options.data && options.data.SearchString) {
    //Multiple hyphens will cause the service to throw a 500 error
    options.data.SearchString = options.data.SearchString.replace(/-+/g, '-');
  }
  options.headers = {};
  if (customerId) {
    options.headers[ApiConstants.SUBSCRIBER_ID_HEADER] = customerId;
  }
  return ThunkHelper(dispatch, SEARCH_AVAILABLE_PRODUCTS_TYPES, options, requestObject);
};
export var retrieveProductsContextPromise = function retrieveProductsContextPromise(dispatch, retrieveProductsContextParam, requestObject, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_PRODUCTS_CONTEXT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveProductContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: retrieveProductsContextParam
  }, requestObject);
};
export var loadAdditionalEpisodesPromise = function loadAdditionalEpisodesPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, LOAD_ADDITIONAL_EPISODES_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveProductContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var retrieveProductContextPromise = function retrieveProductContextPromise(dispatch, customerId, data, requestObject) {
  return ThunkHelper(dispatch, RETRIEVE_PRODUCT_CONTEXT_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveProductContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: data
  }, requestObject);
};
export var retrieveProductContext = function retrieveProductContext(customerId, data) {
  return function (dispatch) {
    return retrieveProductContextPromise(dispatch, customerId, data);
  };
};
export var setPageNumber = function setPageNumber(pageNum) {
  return {
    type: SET_PAGE_NUMBER,
    payload: pageNum
  };
};
export var SET_PRODUCT_ORDER_INVENTORY_REGION_FILTER = 'SET_PRODUCT_ORDER_INVENTORY_REGION_FILTER';
export var setInventoryRegionFilter = function setInventoryRegionFilter(region) {
  return {
    type: SET_PRODUCT_ORDER_INVENTORY_REGION_FILTER,
    payload: region
  };
};
export var SET_PRODUCT_ORDER_SELECTED_INVENTORY_STORES = 'SET_PRODUCT_ORDER_SELECTED_INVENTORY_STORES';
export var setSelectedInventoryStores = function setSelectedInventoryStores(stores) {
  return {
    type: SET_PRODUCT_ORDER_SELECTED_INVENTORY_STORES,
    payload: stores
  };
};
export var FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER = {
  BEGIN: 'FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER.BEGIN',
  FAILURE: 'FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER.FAILURE',
  SUCCESS: 'FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER.SUCCESS'
};
var FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER_TYPES = [FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER.BEGIN, FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER.SUCCESS, FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER.FAILURE];
export var fetchProdutOrderInventoryPromise = function fetchProdutOrderInventoryPromise(dispatch, customerId, inventoryCategory) {
  return ThunkHelper(dispatch, FETCH_PRODUCT_ORDER_SERVICE_IDENTIFIER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscriberInventory',
    data: {
      InventoryCategory: inventoryCategory
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var fetchProductOrderCustomerInventory = function fetchProductOrderCustomerInventory(customerId, inventoryCategory) {
  return function (dispatch) {
    return fetchProdutOrderInventoryPromise(dispatch, customerId, inventoryCategory);
  };
};
export var RETRIEVE_ADDRESSES_CONSTANTS = {
  BEGIN: 'RETRIEVE_ADDRESSES.BEGIN',
  SUCCESS: 'RETRIEVE_ADDRESSES.SUCCESS',
  FAILURE: 'RETRIEVE_ADDRESSES.FAILURE'
};
var retrieveCustomerAddressesPromise = function retrieveCustomerAddressesPromise(dispatch, customerId, includeRemoved) {
  return ThunkHelper(dispatch, values(RETRIEVE_ADDRESSES_CONSTANTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveAddresses',
    data: {
      IncludeRemoved: includeRemoved
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var retrieveCustomerAddresses = function retrieveCustomerAddresses(customerId, includeRemoved) {
  return function (dispatch) {
    return retrieveCustomerAddressesPromise(dispatch, customerId, includeRemoved);
  };
};
export var setSelectedProductsSortOption = function setSelectedProductsSortOption(sortBy) {
  return {
    type: SET_SELECTED_PRODUCTS_SEARCH_OPTION,
    payload: sortBy
  };
};
export var loadAdditionalEpisodes = function loadAdditionalEpisodes(customerId, productId, data) {
  return function (dispatch) {
    return loadAdditionalEpisodesPromise(dispatch, customerId, Object.assign({}, {
      ProductId: productId
    }, data));
  };
};
export var getOrderablePricingExtended = function getOrderablePricingExtended(productId, customerId, couponCode, serviceId) {
  return function (dispatch, getState) {
    dispatch({
      type: RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_CONSTANTS.BEGIN
    });
    return retrieveProductContextPromise(dispatch, customerId, {
      ProductId: productId,
      IncludeOrderablePricingPlans: true,
      RedemptionCodes: [couponCode],
      ServiceId: serviceId
    }).then(function () {
      var customer = CurrentCustomerSelector(getState());
      return getProductMetadataPromise(dispatch, productId, customer.Language);
    }).then(function () {
      dispatch({
        type: RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_CONSTANTS.SUCCESS
      });
    }, function (error) {
      dispatch({
        type: RETRIEVE_PRODUCTS_CONTEXT_AND_METADATA_CONSTANTS.FAILURE,
        payload: error
      });
      return Promise.reject();
    });
  };
};
export var PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT = {
  BEGIN: 'PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT_BEGIN',
  SUCCESS: 'PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT_SUCCESS',
  FAILURE: 'PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT_FAILURE'
};
var PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT_TYPES = [PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT.BEGIN, PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT.SUCCESS, PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT.FAILURE];
export var retrieveOrderContext = function retrieveOrderContext(subscriberId) {
  return function (dispatch) {
    return retrieveOrderContextPromise(dispatch, subscriberId);
  };
};
export var retrieveOrderContextPromise = function retrieveOrderContextPromise(dispatch, subscriberId) {
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, subscriberId),
    data: {}
  };
  return ThunkHelper(dispatch, PRODUCT_ORDER_RETRIEVE_ORDER_CONTEXT_TYPES, params);
};
export var RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER = {
  BEGIN: 'RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER_BEGIN',
  SUCCESS: 'RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER_SUCCESS',
  FAILURE: 'RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER_FAILURE'
};
var RETRIEVE_ORDER_QUOTE_TYPES = [RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER.BEGIN, RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER.SUCCESS, RETRIEVE_ORDER_QUOTE_PRODUCT_ORDER.FAILURE];
export var retrieveOrderQuote = function retrieveOrderQuote(customerId, quoteId) {
  return function (dispatch) {
    return retrieveOrderQuotePromise(dispatch, customerId, quoteId);
  };
};
export var retrieveOrderQuotePromise = function retrieveOrderQuotePromise(dispatch, customerId, quoteId) {
  return ThunkHelper(dispatch, RETRIEVE_ORDER_QUOTE_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderQuote',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      QuoteId: quoteId
    }
  }, {
    calculateTaxesInQuote: true
  });
};
export var UPDATE_SEARCH_CATALOG_PARAMS = 'UPDATE_SEARCH_CATALOG_PARAMS';
export var updateSearchCatalogParams = function updateSearchCatalogParams(searchCatalogParams) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_SEARCH_CATALOG_PARAMS,
      payload: searchCatalogParams
    });
    return retrieveProductsWithInfo(dispatch, searchCatalogParams);
  };
};
var retrieveProductsWithInfo = function retrieveProductsWithInfo(dispatch, searchCatalogParams) {
  dispatch({
    type: RETRIEVE_PRODUCTS_WITH_INFO_CONSTANTS.BEGIN
  });
  var searchBody = {
    PageNumber: searchCatalogParams.PageNumber,
    PageSize: searchCatalogParams.PageSize,
    ProductFilter: searchCatalogParams.ProductFilter,
    SearchString: searchCatalogParams.SearchString,
    SearchEntities: searchCatalogParams.SearchEntities,
    ProductSort: searchCatalogParams.ProductSort
  };
  var requestObject = {
    pageNumber: searchCatalogParams.PageNumber,
    keyword: searchCatalogParams.SearchString
  };
  return searchAvailableProductsPromise(dispatch, searchBody, requestObject, searchCatalogParams.Headers.CustomerId).then(function (products) {
    var productPromises = [];
    var productIds = products.SearchResults.map(function (product) {
      return product.Id;
    });
    while (productIds.length > 0) {
      var sublist = productIds.splice(0, MAX_PRODUCT_CONTEXT_SEARCH_LENGTH);
      var retrieveProductsContextParams = {
        IncludeFeaturedOrderablePricingPlan: true,
        ProductIds: sublist
      };
      if (searchCatalogParams.ProductFilter.CouponCode) {
        retrieveProductsContextParams.RedemptionCodes = [searchCatalogParams.ProductFilter.CouponCode];
      }
      productPromises.push(retrieveProductsContextPromise(dispatch, retrieveProductsContextParams, undefined, searchCatalogParams.Headers.CustomerId));
    }
    Promise.all(productPromises).then(function () {
      dispatch({
        type: RETRIEVE_PRODUCTS_WITH_INFO_CONSTANTS.SUCCESS
      });
    }, function (error) {
      dispatch({
        type: RETRIEVE_PRODUCTS_WITH_INFO_CONSTANTS.FAILURE,
        payload: error
      });
    });
  }, function (error) {
    dispatch({
      type: RETRIEVE_PRODUCTS_WITH_INFO_CONSTANTS.FAILURE,
      payload: error
    });
  });
};
export var SUBMIT_MODIFY_PRODUCT_ORDER = {
  BEGIN: 'SUBMIT_MODIFY_PRODUCT_ORDER_BEGIN',
  SUCCESS: 'SUBMIT_MODIFY_PRODUCT_ORDER_SUCCESS',
  FAILURE: 'SUBMIT_MODIFY_PRODUCT_ORDER_FAILURE'
};
var SUBMIT_MODIFY_PRODUCT_ORDER_TYPES = [SUBMIT_MODIFY_PRODUCT_ORDER.BEGIN, SUBMIT_MODIFY_PRODUCT_ORDER.SUCCESS, SUBMIT_MODIFY_PRODUCT_ORDER.FAILURE];
export var submitModifyOrderPromise = function submitModifyOrderPromise(dispatch, customerId, modificationObject, paymentInstrumentIds, paymentInstruments, recordPaymentInfo) {
  var redemptionCodes = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var discretionaryDiscounts = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var discretionaryDiscountReasonCode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var shippingAddressId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var shippingMethodId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
  var shipToName = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var additionalProperties = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var requestData = getModifyOrderRequestData(modificationObject, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, shippingAddressId, shippingMethodId, shipToName, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode);
  requestData.AdditionalProperties = additionalProperties;
  return ThunkHelper(dispatch, SUBMIT_MODIFY_PRODUCT_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitModifyOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  });
};
export var SUBMIT_RESTORE_ORDER = {
  BEGIN: 'SUBMIT_RESTORE_ORDER_BEGIN',
  SUCCESS: 'SUBMIT_RESTORE_ORDER_SUCCESS',
  FAILURE: 'SUBMIT_RESTORE_ORDER_FAILURE'
};
var SUBMIT_RESTORE_ORDER_TYPES = [SUBMIT_RESTORE_ORDER.BEGIN, SUBMIT_RESTORE_ORDER.SUCCESS, SUBMIT_RESTORE_ORDER.FAILURE];
export var submitRestoreOrderPromise = function submitRestoreOrderPromise(dispatch, customerId, subscriptionId, paymentInstrumentIds, paymentInstruments, recordPaymentInfo) {
  var redemptionCodes = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var discretionaryDiscounts = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var discretionaryDiscountReasonCode = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
  var shippingAddressId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var shippingMethodId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
  var shipToName = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var waiveFee = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : false;
  var waiveFeeReason = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
  var waiveLateFee = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : false;
  var waiveLateFeeReason = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : null;
  var requestData = buildSubmitRestoreOrderRequestData(subscriptionId, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, shippingAddressId, shippingMethodId, shipToName, waiveFee, waiveFeeReason, waiveLateFee, waiveLateFeeReason);
  return ThunkHelper(dispatch, SUBMIT_RESTORE_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitRestoreOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  });
};
export var SUBMIT_PRODUCT_ORDER = {
  BEGIN: 'SUBMIT_PRODUCT_ORDER_BEGIN',
  SUCCESS: 'SUBMIT_PRODUCT_ORDER_SUCCESS',
  FAILURE: 'SUBMIT_PRODUCT_ORDER_FAILURE'
};
var SUBMIT_PRODUCT_ORDER_TYPES = [SUBMIT_PRODUCT_ORDER.BEGIN, SUBMIT_PRODUCT_ORDER.SUCCESS, SUBMIT_PRODUCT_ORDER.FAILURE];
export var SET_REPLACE_ITEM = 'SET_REPLACE_ITEM';
export var setReplaceItem = function setReplaceItem(cartItem) {
  return {
    type: SET_REPLACE_ITEM,
    payload: cartItem
  };
};
export var SET_REPLACEMENT_ITEM = 'SET_REPLACEMENT_ITEM';
export var setReplacementItem = function setReplacementItem(cartItem) {
  return {
    type: SET_REPLACEMENT_ITEM,
    payload: cartItem
  };
};
export var submitOrderPromise = function submitOrderPromise(dispatch, customerId, shoppingCart) {
  var orderTaxLocation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var paymentInstrumentIds = arguments.length > 4 ? arguments[4] : undefined;
  var paymentInstruments = arguments.length > 5 ? arguments[5] : undefined;
  var recordPaymentInfo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  var redemptionCodes = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var discretionaryDiscounts = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  var discretionaryDiscountReasonCode = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var executionOptions = arguments.length > 10 ? arguments[10] : undefined;
  var shippingAddressId = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var shippingMethodId = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var shipToName = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : null;
  var offeringId = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : null;
  var useDefaults = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : true;
  var additionalProperties = arguments.length > 16 ? arguments[16] : undefined;
  var orderDetails = arguments.length > 17 ? arguments[17] : undefined;
  var requestData = buildSubmitOrderRequestData(shoppingCart, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, executionOptions, shippingAddressId, shippingMethodId, shipToName, offeringId, orderTaxLocation, useDefaults, additionalProperties, orderDetails);
  return ThunkHelper(dispatch, SUBMIT_PRODUCT_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  });
};
export var SUBMIT_CHANGE_OF_SERVICE_FOR_SERVICE_FEATURES = {
  BEGIN: 'SUBMIT_CHANGE_OF_SERVICE_FOR_SERVICE_FEATURES.BEGIN',
  SUCCESS: 'SUBMIT_CHANGE_OF_SERVICE_FOR_SERVICE_FEATURES.SUCCESS',
  FAILURE: 'SUBMIT_CHANGE_OF_SERVICE_FOR_SERVICE_FEATURES.FAILURE'
};
export var submitServiceFeatureOrderPromise = function submitServiceFeatureOrderPromise(dispatch, customerId, addItems, modifyItems, removeItems, paymentInstrumentIds, executionOptions, additionalProperties) {
  var data = {
    AddItems: addItems,
    AdditionalProperties: additionalProperties || null,
    ModifyItems: modifyItems,
    RemoveItems: removeItems,
    PaymentInstrumentIds: paymentInstrumentIds,
    ChangeImmediately: true,
    ExecutionDate: executionOptions === null || executionOptions === void 0 ? void 0 : executionOptions.specifiedDate,
    ExecutionDateIntention: executionOptions === null || executionOptions === void 0 ? void 0 : executionOptions.effective
  };
  return ThunkHelper(dispatch, values(SUBMIT_CHANGE_OF_SERVICE_FOR_SERVICE_FEATURES), {
    method: 'post',
    url: 'SubscriberManagement/SubmitChangeOfServiceOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var SUBMIT_GIFT_PRODUCT_ORDER = {
  BEGIN: 'SUBMIT_GIFT_PRODUCT_ORDER_BEGIN',
  SUCCESS: 'SUBMIT_GIFT_PRODUCT_ORDER_SUCCESS',
  FAILURE: 'SUBMIT_GIFT_PRODUCT_ORDER_FAILURE'
};
var SUBMIT_GIFT_PRODUCT_ORDER_TYPES = values(SUBMIT_GIFT_PRODUCT_ORDER);
export var submitGiftOrderPromise = function submitGiftOrderPromise(dispatch, customerId, shoppingCart, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, giftOrderInfo) {
  var redemptionCodes = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var discretionaryDiscounts = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  var discretionaryDiscountReasonCode = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
  var shippingAddressId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
  var shippingMethodId = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
  var shipToName = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var additionalProperties = arguments.length > 13 ? arguments[13] : undefined;
  var requestData = buildSubmitGiftOrderRequestData(shoppingCart, paymentInstrumentIds, paymentInstruments, recordPaymentInfo, giftOrderInfo, redemptionCodes, discretionaryDiscounts, discretionaryDiscountReasonCode, null, shippingAddressId, shippingMethodId, shipToName, additionalProperties);
  return ThunkHelper(dispatch, SUBMIT_GIFT_PRODUCT_ORDER_TYPES, {
    method: 'post',
    url: 'SubscriberManagement/SubmitGiftOrder',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: requestData
  });
};
export var NAVIGATE_TO_CART = 'NAVIGATE_TO_CART';
export var goToCheckoutForModify = function goToCheckoutForModify(_ref) {
  var childSubscriptionId = _ref.childSubscriptionId,
    subscriptionId = _ref.subscriptionId;
  return function (dispatch) {
    dispatch({
      type: NAVIGATE_TO_CART
    });
    if (!isNil(childSubscriptionId)) {
      dispatch(stateGo('index.customercare.customer.subscriptions.detail.modify', {
        mode: PRODUCT_ORDER_WIZARD_MODE.MODIFY,
        childSubscriptionId: childSubscriptionId,
        subscriptionId: subscriptionId
      }));
    } else {
      dispatch(stateGo('index.customercare.customer.subscriptions.detail.modify', {
        mode: PRODUCT_ORDER_WIZARD_MODE.MODIFY,
        subscriptionId: subscriptionId
      }));
    }
  };
};
export var initializeReplaceOrder = function initializeReplaceOrder(cartItem) {
  return function (dispatch) {
    dispatch(setChangeImmediately(true));
    dispatch(setReplaceItem(cartItem));
  };
};
export var goToCheckoutForRestoreSubscription = function goToCheckoutForRestoreSubscription() {
  return function (dispatch) {
    dispatch({
      type: NAVIGATE_TO_CART
    });
    dispatch(stateGo(SUBSCRIPTION_RESTORE_ROUTE, {
      mode: PRODUCT_ORDER_WIZARD_MODE.RESTORE
    }));
  };
};
export var SET_SELECTED_PRODUCT_ID = 'SET_SELECTED_PRODUCT_ID';
export var setSelectedProductId = function setSelectedProductId(productId) {
  return {
    type: SET_SELECTED_PRODUCT_ID,
    payload: productId
  };
};
export var SET_SELECTED_SERIES_CONTAINER_PRODUCT_ID = 'SET_SELECTED_SERIES_CONTAINER_PRODUCT_ID';
export var setSelectedSeriesContainerProductId = function setSelectedSeriesContainerProductId(productId) {
  return {
    type: SET_SELECTED_SERIES_CONTAINER_PRODUCT_ID,
    payload: productId
  };
};
export var SET_SELECTED_SERIES_CONTAINER_INCLUDED_SEASONS_OPTIONS = 'SET_SELECTED_SERIES_CONTAINER_INCLUDED_SEASONS_OPTIONS';
export var setSelectedSeriesContainerSeasons = function setSelectedSeriesContainerSeasons(seasons) {
  return {
    type: SET_SELECTED_SERIES_CONTAINER_INCLUDED_SEASONS_OPTIONS,
    payload: seasons
  };
};
export var SAVE_SERIES_CONTAINER_SEASON_SELECTIONS = 'SAVE_SERIES_CONTAINER_SEASON_SELECTIONS';
export var saveSeriesContainerSeasonSelections = function saveSeriesContainerSeasonSelections(productId, pricingPlanId, selectedEpisodes, quantity) {
  return {
    type: SAVE_SERIES_CONTAINER_SEASON_SELECTIONS,
    payload: {
      productId: productId,
      pricingPlanId: pricingPlanId,
      selectedEpisodes: selectedEpisodes,
      quantity: quantity
    }
  };
};
export var CLEAR_SAVED_SEASONS_SELECTIONS = 'CLEAR_SAVED_SEASONS_SELECTIONS';
export var clearSavedSeasonsSelections = function clearSavedSeasonsSelections() {
  return {
    type: CLEAR_SAVED_SEASONS_SELECTIONS
  };
};
export var CLEAR_CART_SUMMARY_FOR_WAIVE_CHARGE = 'CLEAR_CART_SUMMARY_FOR_WAIVE_CHARGE';
export var clearCartSummaryForWaiveCharge = function clearCartSummaryForWaiveCharge() {
  return {
    type: CLEAR_CART_SUMMARY_FOR_WAIVE_CHARGE
  };
};
export var SET_EPISODES = 'SET_SELECTED_EPISODES';
export var setEpisodes = function setEpisodes(episodes) {
  return {
    type: SET_EPISODES,
    payload: episodes
  };
};
export var SET_OPTIONAL_PRODUCTS = 'SET_OPTIONAL_PRODUCTS';
export var setOptionalProducts = function setOptionalProducts(optionalProducts) {
  return {
    type: SET_OPTIONAL_PRODUCTS,
    payload: optionalProducts
  };
};
export var SET_PICKLIST_PRODUCTS = 'SET_PICKLIST_PRODUCTS';
export var setPicklistProducts = function setPicklistProducts(picklistProducts) {
  return {
    type: SET_PICKLIST_PRODUCTS,
    payload: picklistProducts
  };
};
export var CLEAR_PRODUCTS_METADATA = 'CLEAR_PRODUCTS_METADATA';
export var clearProductsMetadata = function clearProductsMetadata() {
  return {
    type: CLEAR_PRODUCTS_METADATA
  };
};
export var SET_SELECTED_SERVICE_IDENTIFIER_FOR_PRODUCT_ORDER = 'SET_SELECTED_SERVICE_IDENTIFIER_FOR_PRODUCT_ORDER';
export var setSelectedServiceIdentifier = function setSelectedServiceIdentifier(serviceIdentifier) {
  return {
    type: SET_SELECTED_SERVICE_IDENTIFIER_FOR_PRODUCT_ORDER,
    payload: serviceIdentifier
  };
};
export var SET_SELECTED_CUSTOMER_ADDRESS_FOR_PRODUCT_ORDER = 'SET_SELECTED_CUSTOMER_ADDRESS_FOR_PRODUCT_ORDER';
export var setSelectedCustomerAddress = function setSelectedCustomerAddress(customerAddress) {
  return {
    type: SET_SELECTED_CUSTOMER_ADDRESS_FOR_PRODUCT_ORDER,
    payload: customerAddress
  };
};
export var CLEAR_SHOPPING_CART_ERROR = 'PRODUCTS_ORDER_CLEAR_SHOPPING_CART_ERROR';
export var clearShoppingCartError = function clearShoppingCartError() {
  return {
    type: CLEAR_SHOPPING_CART_ERROR
  };
};